import makerjs from 'makerjs'
import Decimal from 'decimal.js'

import { SwitchMXBasic } from './cutouts/SwitchMXBasic'
import { SwitchAlpsSKCM } from './cutouts/SwitchAlpsSKCM'
import { SwitchAlpsSKCP } from './cutouts/SwitchAlpsSKCP'
import { SwitchChocCPG1232 } from './cutouts/SwitchChocCPG1232'
import { SwitchChocCPG1350 } from './cutouts/SwitchChocCPG1350'
import { SwitchOmronB3G } from './cutouts/SwitchOmronB3G'
import { SwitchHiTek725 } from './cutouts/SwitchHiTek725'
import { SwitchIRocks } from './cutouts/SwitchIRocks'
import { SwitchFutabaMA } from './cutouts/SwitchFutabaMA'
import { SwitchMXStem } from './cutouts/SwitchMXStem'
import { SwitchTopreRGB } from './cutouts/SwitchTopreRGB'
import { SwitchECGeneric } from './cutouts/SwitchECGeneric'
import { SwitchECDynaCap } from './cutouts/SwitchECDynaCap'

import { StabilizerMXBasic } from './cutouts/StabilizerMXBasic'
import { StabilizerMXSmall } from './cutouts/StabilizerMXSmall'
import { StabilizerMXSpec } from './cutouts/StabilizerMXSpec'
import { StabilizerAlpsAEK } from './cutouts/StabilizerAlpsAEK'
import { StabilizerAlpsAT101 } from './cutouts/StabilizerAlpsAT101'
import { StabilizerTopreRGB } from './cutouts/StabilizerTopreRGB'
import { StabilizerECGeneric } from './cutouts/StabilizerECGeneric'
import { StabilizerECDynaCap } from './cutouts/StabilizerDynaCap'
import { NullGenerator } from './cutouts/NullGenerator'

import { AcousticMXBasic } from './cutouts/AcousticMXBasic'
import { AcousticMXExtreme } from './cutouts/AcousticMXExtreme'


export function buildPlate(keysArray, generatorOptions) {

    // ----- 解构参数，增加 stabilizerRotation / 外壳边框偏移 -----
    const {
        switchCutoutType = 'mx-basic',
        stabilizerCutoutType = 'mx-spec',
        acousticCutoutType = 'none',
        switchFilletRadius = new Decimal(0.5),
        stabilizerFilletRadius = new Decimal(0.5),
        acousticFilletRadius = new Decimal(0.5),
        unitWidth = new Decimal(19.05),
        unitHeight = new Decimal(19.05),
        kerf = new Decimal(0),
        stabilizerRotation = new Decimal(0),   // 新增：全局卫星轴旋转角度（度）
        mergeStabilizer = true,                // 是否合并卫星轴和轴体开孔
        // 外壳边框偏移（仅当 plateUseCaseBorders 为 true 时生效）
        plateUseCaseBorders = false,
        borderTop = new Decimal(0),
        borderBottom = new Decimal(0),
        borderLeft = new Decimal(0),
        borderRight = new Decimal(0),
    } = generatorOptions;

    let canvas = { models: {} }
    let id = 0

    let minX = new Decimal(Number.POSITIVE_INFINITY)
    let minY = new Decimal(Number.POSITIVE_INFINITY)
    let maxX = new Decimal(Number.NEGATIVE_INFINITY)
    let maxY = new Decimal(Number.NEGATIVE_INFINITY)

    let switchGenerator;
    console.log(generatorOptions.switchCutoutType)
    switch (switchCutoutType) {
        case "mx-basic":
            switchGenerator = new SwitchMXBasic();
            break;
        case "alps-skcm":
            switchGenerator = new SwitchAlpsSKCM();
            break;
        case "choc-cpg1232":
            switchGenerator = new SwitchChocCPG1232();
            break;
        case "choc-cpg1350":
            switchGenerator = new SwitchChocCPG1350();
            break;
        case "omron-b3g":
            switchGenerator = new SwitchOmronB3G();
            break;
        case "alps-skcp":
            switchGenerator = new SwitchAlpsSKCP();
            break;
        case "hitek-725":
            switchGenerator = new SwitchHiTek725();
            break;
        case "i-rocks":
            switchGenerator = new SwitchIRocks();
            break;
        case "futaba-ma":
            switchGenerator = new SwitchFutabaMA();
            break;
        case "mx-stem":
            switchGenerator = new SwitchMXStem();
            break;
        case "ec-generic":
            switchGenerator = new SwitchECGeneric();
            break;
        case "ec-dynacap":
            switchGenerator = new SwitchECDynaCap();
            break;
        default:
            console.error("Unsupported switch type")
            return null
    }

    let stabilizerGenerator = null
    if (generatorOptions.customStabilizerGenerator) {
        stabilizerGenerator = generatorOptions.customStabilizerGenerator
    } else {
    switch (stabilizerCutoutType) {
        case "mx-basic":
            stabilizerGenerator = new StabilizerMXBasic();
            break;
        case "mx-small":
            stabilizerGenerator = new StabilizerMXSmall();
            break;
        case "mx-spec":
            stabilizerGenerator = new StabilizerMXSpec();
            break;
        case "alps-aek":
            stabilizerGenerator = new StabilizerAlpsAEK();
            break;
        case "alps-at101":
            stabilizerGenerator = new StabilizerAlpsAT101();
            break;
        case "none":
            stabilizerGenerator = new NullGenerator();
            break;
            case "ec-generic":
            stabilizerGenerator = new StabilizerECGeneric();
            break;
        case "ec-dynacap":
            stabilizerGenerator = new StabilizerECDynaCap();
            break;
        default:
            console.error("Unsupported stabilizer type")
            return null
    }
    }

    let acousticGenerator = null
    switch (acousticCutoutType) {
        case "none":
            acousticGenerator = new NullGenerator();
            break;
        case "mx-basic":
            acousticGenerator = new AcousticMXBasic();
            break;
        case "mx-extreme":
            acousticGenerator = new AcousticMXExtreme();
            break;
        default:
            console.error("Unsupported acoustic cutout type")
            return null
    }

    for (const key of keysArray) {

        let origin = {
            x: key.centerX.times(unitWidth),
            y: key.centerY.times(unitHeight)
        }

        const originNum = [origin.x.toNumber(), origin.y.times(-1).toNumber()]

        // Render switch
        let switchCutout = makerjs.model.rotate(switchGenerator.generate(key, generatorOptions), key.angle.plus(key.independentSwitchAngle).times(-1).toNumber())
        switchCutout.origin = originNum

        // ----- Render stabilizer with global rotation -----
        let stabilizerCutout = stabilizerGenerator.generate(key, generatorOptions)
        if (stabilizerCutout) {
            stabilizerCutout.origin = originNum
            // 计算总旋转角度：键自身旋转（负） + 键独立卫星轴角度（负） + 全局卫星轴旋转
            const totalAngle = key.angle.plus(key.stabilizerAngle).times(-1).plus(stabilizerRotation);
            stabilizerCutout = makerjs.model.rotate(stabilizerCutout, totalAngle.toNumber(), originNum)
        }

        // Combine switch and stabilizer cutouts if they overlap
        if (stabilizerCutout && mergeStabilizer) {
            try {
                // Use combineUnion to merge overlapping cutouts
                const combined = makerjs.model.combineUnion(switchCutout, stabilizerCutout)
                canvas.models["Cutout" + id.toString()] = combined
            } catch (e) {
                // If combine fails, add them separately
                canvas.models["Switch" + id.toString()] = switchCutout
                canvas.models["Stabilizer" + id.toString()] = stabilizerCutout
            }
        } else {
            canvas.models["Switch" + id.toString()] = switchCutout
            if (stabilizerCutout) {
                canvas.models["Stabilizer" + id.toString()] = stabilizerCutout
            }
        }

        // Render acoustic cutouts
        let acousticCutout = acousticGenerator.generate(key, generatorOptions)
        if (acousticCutout) {
            acousticCutout.origin = originNum
            acousticCutout = makerjs.model.rotate(acousticCutout, key.angle.plus(key.stabilizerAngle).times(-1).toNumber(), originNum)
            canvas.models["Acoustic" + id.toString()] = acousticCutout
        }

        // 追踪边界（单位矩形旋转后的轴对齐包围盒）
        const halfW = key.width.times(unitWidth).times(0.5).toNumber()
        const halfH = key.height.times(unitHeight).times(0.5).toNumber()
        const ox = origin.x.toNumber()
        const oy = origin.y.toNumber()
        const rad = key.angle.times(-1).toNumber() * Math.PI / 180
        const cosA = Math.cos(rad)
        const sinA = Math.sin(rad)
        const corners = [
            [ox + (-halfW * cosA - (-halfH) * sinA), oy + (-halfW * sinA + (-halfH) * cosA)],
            [ox + (halfW * cosA - (-halfH) * sinA), oy + (halfW * sinA + (-halfH) * cosA)],
            [ox + (halfW * cosA - halfH * sinA), oy + (halfW * sinA + halfH * cosA)],
            [ox + (-halfW * cosA - halfH * sinA), oy + (-halfW * sinA + halfH * cosA)],
        ]
        for (const [cx, cy] of corners) {
            if (cx < minX.toNumber()) minX = new Decimal(cx)
            if (cx > maxX.toNumber()) maxX = new Decimal(cx)
            if (cy < minY.toNumber()) minY = new Decimal(cy)
            if (cy > maxY.toNumber()) maxY = new Decimal(cy)
        }

        id += 1
    }

    // Draw outer boundaries
    const boardRadiusNum = generatorOptions.boardRadius ? generatorOptions.boardRadius.toNumber() : 0
    let left = minX.toNumber()
    let right = maxX.toNumber()
    let top = maxY.times(-1).toNumber()
    let bottom = minY.toNumber()

    // 若开启「定位板偏移」，按外壳上下左右边框宽度向外扩展最外轮廓
    if (plateUseCaseBorders) {
        const bt = borderTop.toNumber ? borderTop.toNumber() : Number(borderTop) || 0
        const bb = borderBottom.toNumber ? borderBottom.toNumber() : Number(borderBottom) || 0
        const bl = borderLeft.toNumber ? borderLeft.toNumber() : Number(borderLeft) || 0
        const br = borderRight.toNumber ? borderRight.toNumber() : Number(borderRight) || 0
        left -= bl
        right += br
        top -= bt
        bottom += bb
    }

    let boundingBox
    if (boardRadiusNum > 0) {
        // Rounded corners
        const r = Math.min(boardRadiusNum, (right - left) / 2, (bottom - top) / 2)
        boundingBox = {
            paths: {
                // Top edge
                lineTop: new makerjs.paths.Line([left + r, top], [right - r, top]),
                // Right edge
                lineRight: new makerjs.paths.Line([right, top + r], [right, bottom - r]),
                // Bottom edge
                lineBottom: new makerjs.paths.Line([right - r, bottom], [left + r, bottom]),
                // Left edge
                lineLeft: new makerjs.paths.Line([left, bottom - r], [left, top + r]),
                // Corner arcs
                arcTopRight: new makerjs.paths.Arc([right - r, top + r], r, 270, 360),
                arcBottomRight: new makerjs.paths.Arc([right - r, bottom - r], r, 0, 90),
                arcBottomLeft: new makerjs.paths.Arc([left + r, bottom - r], r, 90, 180),
                arcTopLeft: new makerjs.paths.Arc([left + r, top + r], r, 180, 270)
            }
        }
    } else {
        // Sharp corners (original)
        let upperLeft = [left, top]
        let upperRight = [right, top]
        let lowerLeft = [left, bottom]
        let lowerRight = [right, bottom]

        boundingBox = {
            paths: {
                lineTop: new makerjs.paths.Line(upperLeft, upperRight),
                lineBottom: new makerjs.paths.Line(lowerLeft, lowerRight),
                lineLeft: new makerjs.paths.Line(upperLeft, lowerLeft),
                lineRight: new makerjs.paths.Line(upperRight, lowerRight)
            }
        }
    }

    canvas.models["BoundingBox0"] = boundingBox

    return canvas
}